export const FEATURED_COUNTRY_CODES = ['en-gb', 'en-us', 'en-ca', 'en-au', 'en-nz', 'en-de', 'en-fr', 'en-ch']
